import { useCallback, useEffect } from "react"

import { removeStoredValue } from "@/lib/safe-storage"

export type Appearance = "light" | "dark" | "system"

const applyDarkTheme = () => {
  document.documentElement.classList.add("dark")
  document.documentElement.style.colorScheme = "dark"
}

export function initializeTheme() {
  applyDarkTheme()
  // Drop leftover preferences from when theme switching existed.
  removeStoredValue("appearance")
}

export function useAppearance() {
  const updateAppearance = useCallback((_mode: Appearance) => {
    applyDarkTheme()
  }, [])

  useEffect(() => {
    applyDarkTheme()
  }, [])

  return { appearance: "dark" as Appearance, updateAppearance } as const
}
